/** Settings screen: SettingsPage, CategoriesEditor, controls, TimezoneCombobox. */
export const settings = {
  'settings.title': 'Settings',
  'settings.section.ai': 'AI',
  'settings.section.appearance': 'Appearance',
  'settings.section.calendar': 'Calendar',
  'settings.section.data': 'Data',
  'settings.appearance.theme': 'Theme',
  'settings.appearance.density': 'Density',
  'settings.appearance.language': 'Language',
  'settings.appearance.language.hint': 'The language of the interface and AI replies.',
  'settings.appearance.language.en': 'English',
  'settings.appearance.language.de': 'Deutsch',

  'settings.saving': 'Saving…',

  'settings.ai.model.label': 'Model',
  'settings.ai.model.hint': 'Snapshotted onto a conversation when it is created.',
  'settings.ai.maxTokens.label': 'Max response tokens',
  'settings.ai.maxTokens.hint': "How long Claude's answer may be.",
  'settings.ai.thinking.label': 'Extended thinking',
  'settings.ai.thinking.hint':
    'Lets the model reason before answering. Slower, better on hard questions.',
  'settings.ai.prompt.label': 'Default system prompt',
  'settings.ai.prompt.hint': 'Pre-selected on a new conversation.',
  'settings.ai.prompt.none': '(none)',
  'settings.ai.prompt.libraryDefault': ' · library default',
  'settings.ai.prompt.manageLibrary': 'Manage the prompt library',
  'settings.ai.contextBudget.label': 'Context budget',
  'settings.ai.contextBudget.hint':
    'Maximum tokens of attached page content sent with each message.',

  'settings.appearance.theme.system': 'System',
  'settings.appearance.theme.light': 'Light',
  'settings.appearance.theme.dark': 'Dark',
  'settings.appearance.density.hint': 'How much fits on screen. Compact is the default.',
  'settings.appearance.density.compact': 'Compact',
  'settings.appearance.density.comfortable': 'Comfortable',
  'settings.appearance.density.previewRow': 'A sidebar row, at this density',

  'settings.calendar.weekStart.label': 'Week starts on',
  'settings.calendar.weekStart.monday': 'Monday',
  'settings.calendar.weekStart.tuesday': 'Tuesday',
  'settings.calendar.weekStart.wednesday': 'Wednesday',
  'settings.calendar.weekStart.thursday': 'Thursday',
  'settings.calendar.weekStart.friday': 'Friday',
  'settings.calendar.weekStart.saturday': 'Saturday',
  'settings.calendar.weekStart.sunday': 'Sunday',
  'settings.calendar.timezone.label': 'Timezone',
  'settings.calendar.timezone.hint': 'Every event is stored as an instant and shown in this zone.',
  'settings.calendar.categories.label': 'Event categories',
  'settings.calendar.categories.hint': 'A name and a colour. Not a setting — CRUD.',

  'settings.data.description':
    'Not settings — pointers, and the one destructive action. It lives here because it is where people look for it.',
  'settings.data.backup.label': 'Backup',
  'settings.data.backup.hint': 'There is no in-app export, by design.',
  'settings.data.backup.bodyPrefix': 'A backup is two artifacts: a Postgres dump ',
  'settings.data.backup.bodyAnd': 'and',
  'settings.data.backup.bodySuffix':
    ' the uploads volume. Restoring only the dump leaves every image broken.',
  'settings.data.storage.label': 'Storage used',
  'settings.data.storage.loading': '…',
  'settings.data.storage.pages.one': '{count} page',
  'settings.data.storage.pages.other': '{count} pages',
  'settings.data.storage.trashed': ' ({count} in the trash)',
  'settings.data.storage.images.one': '{count} image',
  'settings.data.storage.images.other': '{count} images',

  'settings.dangerZone.title': 'Danger zone',
  'settings.dangerZone.emptyTrash.label': 'Empty trash',
  'settings.dangerZone.emptyTrash.description':
    'Permanently deletes every archived page and everything under it, and reaps the images only those pages used. Irreversible.',
  'settings.dangerZone.emptyTrash.button': 'Empty trash ({count})',

  'settings.categories.empty':
    'No categories yet. Events without one still work — they are simply uncoloured.',
  'settings.categories.colorOf': 'Colour of {name}',
  'settings.categories.nameOf': 'Name of {name}',
  'settings.categories.deleteOf': 'Delete {name}',
  'settings.categories.deleteDialog.title': 'Delete the “{name}” category?',
  'settings.categories.deleteDialog.descriptionPrefix': 'The events in it are ',
  'settings.categories.deleteDialog.descriptionNot': 'not',
  'settings.categories.deleteDialog.descriptionSuffix':
    ' deleted — they simply lose their category and their colour. You can put them in another one afterwards.',
  'settings.categories.deleteDialog.confirm': 'Delete category',
  'settings.categories.colorOfNew': 'Colour of the new category',
  'settings.categories.newNameLabel': 'New category name',
  'settings.categories.newNamePlaceholder': 'Session, Quest, Deadline…',
  'settings.categories.save': 'Save the category',
  'settings.categories.add': 'Add a category',

  'settings.timezone.searchPlaceholder': 'Search timezones…',
  'settings.timezone.empty': 'No timezone matches.',
  'settings.timezone.useDetected': 'Detected: {zone} — use this',
} as const;
